






















































































import { defineComponent, PropType } from '@vue/composition-api';
import { TranslateResult } from 'vue-i18n';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import { SUBMIT_ERROR_STATUS } from '../const';
import ErrorTableExpand from './error-table-expand.vue';
import ErrorTableColDetail from './error-table-col-detail.vue';
import ErrorTableColStatus from './error-table-col-status.vue';

export default defineComponent({
  components: {
    QuestionTooltip,
    ErrorTableExpand,
    ErrorTableColDetail,
    ErrorTableColStatus,
  },
  props: {
    // 是否需要展开报错信息
    showExpand: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    otherMsg: {
      type: String as PropType<string | TranslateResult>,
      default: '',
    },
    otherMsgTooltipList: {
      type: Array as PropType<string[] | TranslateResult[]>,
      default: () => [],
    },
    // 用于埋点用
    level: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      SUBMIT_ERROR_STATUS,
    };
  },
});
